import { render, staticRenderFns } from "./RebateNote.vue?vue&type=template&id=ccddd4cc&"
import script from "./RebateNote.vue?vue&type=script&lang=js&"
export * from "./RebateNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports